// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-sidenav {
  padding-top: 20%;
  width: 100%;
}
#app-sidenav .unread-items-badge {
  display: inline-block;
  border-radius: 2em;
  color: white;
  background-color: #0f5596;
  margin-left: 12px;
  text-align: center;
  font-weight: 500;
  font-family: proxima-nova;
  height: 25px;
  min-width: 25px;
  padding: 6px;
  line-height: 15px;
}
#app-sidenav .k-menu {
  font-size: 18px;
}
#app-sidenav .k-menu-item {
  font-weight: lighter;
  color: #0f5596;
  background-color: white;
  border-left: 10px solid transparent;
  width: 95%;
}
#app-sidenav .k-menu-item .k-link.k-menu-link {
  display: flex;
  align-items: center;
}
#app-sidenav .k-menu-item.active {
  border-left: 10px solid coral;
  font-weight: 500;
}
#app-sidenav .k-menu-item .k-icon {
  font-size: 20px;
  margin-right: 8px;
  margin-left: 8px;
}
@media screen and (max-width: 960px) {
  #app-sidenav {
    padding-top: 3%;
  }
}

.k-menu-vertical > .k-menu-item > .k-menu-link {
  padding: 2px;
}

.ml-nav-fix-target > .k-menu-link {
  padding: unset;
  outline: unset;
  color: unset;
  display: unset;
  flex-direction: unset;
  flex: unset;
  align-items: unset;
  position: unset;
  white-space: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/sidenav/sidenav.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,WAAA;AACJ;AACI;EACI,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AACR;AAEI;EACI,eAAA;AAAR;AAGI;EACI,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,mCAAA;EACA,UAAA;AADR;AAGQ;EACI,aAAA;EACA,mBAAA;AADZ;AAIQ;EACI,6BAAA;EACA,gBAAA;AAFZ;AAKQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AAHZ;AAOI;EA/CJ;IAgDQ,eAAA;EAJN;AACF;;AAOA;EACI,YAAA;AAJJ;;AAOA;EACI,cAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAJJ","sourcesContent":["#app-sidenav {\n    padding-top: 20%;\n    width: 100%;\n\n    .unread-items-badge {\n        display: inline-block;\n        border-radius: 2em;\n        color: white;\n        background-color: #0f5596;\n        margin-left: 12px;\n        text-align: center;\n        font-weight: 500;\n        font-family: proxima-nova;\n        height: 25px;\n        min-width: 25px;\n        padding: 6px;\n        line-height: 15px;\n    }\n\n    .k-menu {\n        font-size: 18px;\n    }\n\n    .k-menu-item {\n        font-weight: lighter;\n        color: #0f5596;\n        background-color: white;\n        border-left: 10px solid transparent;\n        width: 95%;\n\n        .k-link.k-menu-link {\n            display: flex;\n            align-items: center;\n        }\n\n        &.active {\n            border-left: 10px solid coral;\n            font-weight: 500;\n        }\n\n        .k-icon {\n            font-size: 20px;\n            margin-right: 8px;\n            margin-left: 8px;\n        }\n    }\n\n    @media screen and (max-width: 960px) {\n        padding-top: 3%;\n    }\n}\n\n.k-menu-vertical > .k-menu-item > .k-menu-link {\n    padding: 2px;\n}\n\n.ml-nav-fix-target > .k-menu-link {\n    padding: unset;\n    outline: unset;\n    color: unset;\n    display: unset;\n    flex-direction: unset;\n    flex: unset;\n    align-items: unset;\n    position: unset;\n    white-space: unset;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
